export default {
  app: {
    title: 'RODOSZ'
  },

  pages: {
    index: 'Kezdőlap'
  },
  menu: {
    logout: 'Kijelentkezés',
    personalData: 'Személyes adatok',
    dashboard: 'Irányítópult',
    userManagement: 'Felhasználók',
    person: 'Személyek',
    masterData: 'Törzsadatok',
    transactionData: 'Tranzakciós napló',
    loginTransactionData: 'Bejelentkezési napló',
    monthlyDataEntry: 'Havi adatrögzítés',
    postGraduateEducationTemplate: ' Szakképzés Minták',
    export: 'Exportok',
    deploymentStage: {
      cts_test: 'Fejlesztői teszt',
      pte_test: 'IIG teszt',
      prod: 'Éles',
      local: 'Lokális',
      dev: 'DEV szerver'
    }
  },

  dashboard: {
    greeting: 'Üdvözöljük'
  },

  label: {
    yes: 'Igen',
    no: 'Nem'
  },

  user: {
    label: {
      name: 'Név',
      username: 'Felhasználónév',
      email: 'E-mail',
      role: 'Szerep',
      enabled: 'Engedélyezve',
      userType: 'Típus',
      neptunCode: 'Neptun kód'
    },
    filter: {
      keyword: 'Keresés'
    },
    enabled: {
      label: 'Engedélyezve',
      true: 'Igen',
      false: 'Nem'
    },
    role: {
      admin: 'Rendszer Adminisztrátor',
      reziAdmin: 'Adminisztrátor',
      staff: 'Munkatárs'
    },
    type: {
      label: 'Típus',
      STANDARD: 'PTE',
      GUEST: 'Vendég'
    },
    details: {
      title: 'Felhasználói adatok',
      name: 'Név',
      username: 'Felhasználónév',
      email: 'E-mail',
      enabled: 'Engedélyezve',
      type: 'Típus',
      role: 'Szerep',
      neptunCode: 'Neptun kód'
    },
    notification: {
      userSuccess: 'Felhasználó mentése sikeres!',
      userError: 'Hiba a Felhasználó mentése közben!',
      deleteSuccess: 'Felhasználó törlése sikeres!',
      deleteError: 'Hiba a Felhasználó törlése közben!',
      activationUserSuccess: 'Felhasználó sikeresen aktiválva',
      activationUserError: 'Hiba a felhasználó aktiválása közben',
      inactivationUserSuccess: 'Felhasználó sikeresen inaktiválva',
      inactivationUserError: 'Hiba a felhasználó inaktiválása közben',
      copyToClipboard: 'Vágólapra másolva!'
    },
    dialog: {
      delete: {
        title: 'Felhasználó törlése',
        text: 'Biztosan törli a "{name}" nevű Felhasználót?'
      }
    }
  },

  educationProgress: {
    successed: 'Kalkulált teljesítés',
    manualSuccessed: 'Rögzített teljesítés',
    successedExam: 'Vizsga teljesítve',
    notSuccessedExam: 'Vizsga nincs teljesítve',
    allItemsSuccess: 'Összes elem teljesítve',
    notAllItemsSuccess: 'Nincs minden elem teljesítve',
    tutorReportPeriods: {
      title: 'Jelentési időszakok',
      empty: 'Nincsenek megadva'
    }
  },

  button: {
    add_new: 'Új hozzáadása',
    addMonth: 'Új hónap létrehozása',
    addModule: 'Almodul létrehozása',
    addElement: 'Elem létrehozása',
    addReport: 'Jelentés létrehozása',
    acceptReports: 'Hónap lezárása',
    copyDatas: 'Adatok másolása',
    activate: 'Aktiválás',
    inactivate: 'Inaktiválás',
    activation_email: 'Aktiváló e-mail küldése',
    edit: 'Szerkesztés',
    open: 'Megtekintés',
    setSucces: 'Teljesítés hozzáadása',
    delete: 'Törlés',
    calculate: 'Adatok számítása',
    save: 'Mentés',
    showReports: 'Jelentések megjelenítése',
    hideReports: 'Jelentések elrejtése',
    finalize: 'Véglegesítés',
    paymentIndicate: 'Kifizetés időzítése',
    back: 'Vissza',
    cancel: 'Mégse',
    openProgress: 'Előrehaladás megtekintése',
    summary: 'Összegzés',
    export_absolutorium: 'Abszolutórium exportálás',
    export_entry_contract: 'Szakképzési szerződés exportálás',
    gotoUser: 'Személy megnyitása',
    openData: 'Megnyitása',
    exportTutorReports: 'Tutori jelentések exportálása',
    exportTransactionData: 'Tranzakciós napló exportálása',
    exportLoginTransactionData: 'Bejelentkezési napló exportálása',
    download: 'Letöltés',
    addNoTutor: 'Tutor nélküli lehetőség',
    copy: 'Másolás',
    copy_legislation: 'Jogszabály másolása',
    exportDesc: 'Exportálás csökkenő sorrendben',
    exportAsc: 'Exportálás növekvő sorrendben'
  },

  export: {
    monthlyReportModal: {
      title: 'Havi jelentési lista'
    },
    candidateWithoutReportModal: {
      title: 'Nem adtak le teljesítésigazolást'
    },
    label: {
      candidateWithCourse: 'Jelöltek képzéssel',
      monthlyReport: 'Havi jelentés lista',
      candidateWithoutReport: 'Nem adtak le teljesítésigazolást',
      personWithCourse: 'Tanfolyamot végeztek',
      personWithoutCourse: 'Nem végzett tanfolyamot',
      tutorData: 'Tutorok adatai',
      unclosedMonths: 'Visszaigazolatlan hónapok'
    }
  },

  accessDenied: {
    title: 'Hozzáférés megtagadva'
  },

  modal: {
    save: 'Mentés',
    saveAndNavigateToPerson: 'Tovább'
  },

  filter: {
    search: 'Keresés',
    keyword: 'Keresés'
  },
  list: {
    type: {
      full: 'Teljes',
      partial: 'Részleges'
    },
    label: {
      name: 'név',
      code: 'kód',
      date: 'dátum',
      comment: 'megjegyzés',
      amount: 'összeg',
      numberOfWorkingDays: 'munkanapok száma',
      contacts: 'elérhetőségek',
      director: 'vezető neve',
      nameOfAdministrator: 'ügyintéző neve',
      administratorContactDetails: 'ügyintéző elérhetőségek',
      hospitalName: 'korház neve',
      address: 'cím',
      email: 'email',
      phoneNumber: 'telefonszám',
      candidate: 'jelölt',
      tutor: 'tutor',
      times: 'alkalom',
      orderNumber: 'Sorszám',
      // passive: 'passzív',
      // deceased: 'elhunyt',
      prefix: 'előtag',
      // medicalSealNumber: 'orvosi pecsétszám',
      medicalSealNumber: 'psz',
      idOfQualification: 'szakképesítés  oklevél száma',
      placeOfAcquisition: 'megszerzés helye',
      dateOfAcquisition: 'megszerzés dátuma',
      specialityName: 'szak neve',
      specialityNames: 'szak nevek',
      registrationNumber: 'iktatószám',
      contractingParty: 'szerződő',
      fromDate: 'dátumtól',
      toDate: 'dátumig',
      activeFromDate: 'képzés aktivitás dátumtól',
      activeToDate: 'képzés aktivitás dátumig',
      instructorStatusName: 'oktatói státusz',
      contractSentOut: 'szerződés kiküldve',
      contractIsFinal: 'szerződés végleges',
      authorizedToSign: 'aláírásra jogosult',
      contractingAccountNumber: 'szerződő számlaszáma',
      employerName: 'munkáltató neve',
      employerPosition: 'munkáltató beosztása',
      companyRegistrationNumber: 'cégjegyzékszám',
      statisticalNumber: 'statisztikai számjel',
      diplomaType: 'diploma tipus',
      taxNumber: 'adószám',
      personName: 'pecsétszám - név ',
      reasonForAbsenceName: 'jogcímkód',
      numberOfDays: 'napok száma',
      educationLocationName: 'képzési hely ',
      educationId: 'képzés ID',
      active: 'aktív',
      hasPartialExam: 'részvizsga',
      validDate: 'érvényeség',
      legislationName: 'jogszabály',
      legislationNames: 'jogszabályok',
      legalRelationshipType: 'Jogviszony',
      educationTypeName: 'Képzési fajta',
      educationTypeNames: 'Képzési fajták',
      educationFormName: 'Képzési forma',
      educationFormNames: 'Képzési formák',
      educationSystem: 'Képzési rendszer',
      statusCode: 'státusz',
      educationStatusCode: 'Képzés státusz',
      postGraduateEducationTemplateName: 'Szakképzés Minta',
      educationContractNumber: 'Szakképzési megállapodás száma',
      courseName: 'Kurzus név',
      postGraduateEducationElementName: 'szakképzés elem',
      // postGraduateEducationElementQuantity: 'szakképzés elem mennyiség',
      postGraduateEducationElementQuantity: 'mennyiség',
      educationName: 'képzés név',
      numberOfDaysWorked: 'ledolgozott',
      numberOfTutoringDays: 'tutori napok',
      monthName: 'hónap',
      numberOfOnCallVisits: 'ügyeletek száma',
      amountOfOnCallVisits: 'ügyeletek összege',
      numberOfOtherDays: 'egyéb napok',
      numberOfHolidays: 'szabadságok',
      numberOfSickLeave: 'táppénzes',
      amountOfTutor: 'tutor összege',
      amountOfEducationLocation: 'képzési hely összege',
      costOfMaterials: 'anyagköltség',
      paymentIndicationForTutor: 'kifizetés inditványozása',
      paymentIndicationMessageForTutor: 'Kifizetés indítványozás megjegyzés',
      paymentIndicationMessage: 'Megjegyzés módosítása',
      payable: 'fizethető',
      dateOfSubmission: 'leadás dátuma',
      dateOfClosure: 'lezárás dátuma',
      otherAbsences: 'egyéb távollét',
      eventType: 'esemény típusa',
      eventDate: 'esemény dátuma',
      tutorName: 'tutor név',
      id: 'id',
      specialtyGroupList: 'Szakcsoportok',
      partExamName: 'részvizsga név',
      dateOfExam: 'részvizsga időpontja',
      examResult: 'részvizsga eredménye',
      educationElementName: 'szakképzés elem',
      pstNumber: 'PST szám',
      dateOfPayment: 'befizetés dátuma',
      creationTime: 'létrehozás időpontja',
      educationStatus: 'Képzés státusz',
      actualEducationStatus: 'Aktuális képzés státusz',
      noTutorAdded: 'Tutor nélküli hozzárendelve',
      workSchedule: 'Munkarend',
      absolutoriumFromDate: 'abszolutórium dátumtól',
      absolutoriumToDate: 'abszolutórium dátumig',
      entryFromDate: 'belépés dátumtól',
      entryToDate: 'belépés dátumig',
      type: 'Típus',
      educationElementAmount: 'Mennyiség'
    },
    details: {
      name: 'név',
      code: 'kód',
      comment: 'megjegyzés',
      quantity: 'mennyiség',
      parent: 'szülő',
      amount: 'összeg',
      contacts: 'elérhetőségek',
      diplomaType: 'diploma tipus',
      numberOfWorkingDays: 'munkanapok száma',
      director: 'vezető neve',
      nameOfAdministrator: 'ügyintéző neve',
      administratorContactDetails: 'ügyintéző elérhetőségek',
      hospitalName: 'korház neve',
      address: 'cím',
      zipCode: 'irányítószám',
      cityName: 'város',
      addressName: 'helyszín',
      themeNumber: 'témaszám',
      taxNumber: 'adószám',
      maidenName: 'születési név',
      dateOfBirth: 'születési dátum',
      countryOfBirthName: 'születési ország',
      citizenship: 'állampolgárság',
      placeOfBirth: 'születési hely',
      motherName: 'anyja neve',
      dateOfGraduation: 'diploma megszerzésének ideje',
      degreeNumber: 'diploma száma',
      graduationLocation: 'diploma kiállítási helye',
      // educationLocationName: 'képzésihely',
      educationLocationName: 'munkahely',
      // positionName: 'beosztás',
      positionName: 'szakképzési pozíció',
      accountNumber: 'számlaszám',
      taj: 'TAJ',
      pensionerMasterNumber: 'nyugdíjas törzsszám',
      healthcareName: 'EÜ név',
      scientificDegreeDate: 'tudományos fokozat megszerzésének ideje',
      scientificDegreePlace: 'tudományos fokozat megszerzésénekhelye',
      ehaCode: 'EHA kód',
      specialityChanger: 'szakváltó',
      universityTransfer: 'egyetemváltó',
      jobChanger: 'munkahelyváltó',
      specialityChangerComment: 'szakváltó megjegyzés',
      universityTransferComment: 'egyetemváltó megjegyzés',
      jobChangerComment: 'munkahelyváltó megjegyzés',
      instructorStatusName: 'oktatói státusz',
      eszjv: 'ESzJV',
      home: {
        zipCode: 'lakcím irányítószám',
        cityName: 'lakcím város',
        addressName: 'lakcím helyszín'
      },
      mailing: {
        zipCode: 'levelezésicím irányítószám',
        cityName: 'levelezésicím város',
        addressName: 'levelezésicím helyszín'
      },
      specialityName: 'szak',
      statusCode: 'státusz',
      educationTypeName: 'képzési fajta',
      educationFormName: 'képzési forma',
      educationSystem: 'képzési rendszer',
      nicheProfession: 'hiányszakma',
      tender: 'pályázatos',
      halfQuota: '1/2 keretszám',
      dateOfEntry: 'belépés dátuma',
      exitDate: 'kilépés dátuma',
      pauseStartDate: 'szüneteltetés kezdet',
      pauseEndDate: 'szüneteltetés vég',
      okfoSupportEndDate: 'OKFŐ támogatás vége',
      closureDate: 'végzés tényleges dátuma',
      coreEducationFinancingEndDate: 'törzsképzés finanszírosásának vége',
      coreEducationEndDate: 'törzsképzés végének várható időpontja',
      coreEducationExaminationDate: 'törzsképzési vizsga időpontja',
      expectedFinishingDate: 'végzés várható dátuma',
      absolutoriumDate: 'abszolutorium dátuma',
      appointmentEndDate: 'kinevezes vég dátuma',
      postGraduateEducationTemplateName: 'Szakképzés Minta',
      educationContractNumber: 'Szakképzési megállapodás száma',
      designatedTimePeriod: 'Kijelölt időtartam',
      designatedPraxis: 'Kijelölt praxis (3 hó)',
      educationName: 'Képzés név',
      courseName: 'tanfolyam név',
      courseNames: 'tanfolyam nevek',
      workSchedule: 'munkarend'
    }
  },

  tabs: {
    specialties: 'Szakok',
    amounts: 'Összegek',
    instructorStatuses: 'Oktatói státuszok',
    educationProgress: 'Képzés előrehaladás',
    educationTypes: 'Képzési fajták',
    educationForms: 'Képzési formák',
    educationLocations: 'Képzési helyek',
    courses: 'Tanfolyamok',
    hospitals: 'Kórházak',
    workMonths: 'Hónapok',
    qualifications: 'Szakképesítések',
    details: 'Alapadatok',
    contracts: 'Szerződések',
    absences: 'Szüneteltetések',
    reducedWorkSchedules: 'Csökkentett munkarend',
    personHasEducationLocation: 'Munkahelyek',
    legislations: 'Jogszabályok',
    post_graduaion_eucation_template: 'Szakképzési terv',
    partExam: 'Részvizsga',
    part_exam: 'Részvizsga',
    educations: 'Képzések',
    tutorReports: 'Tutori jelentések',
    tutorPayouts: 'Tutori kifizetések',
    yearly_events: 'Éves események',
    partExams: 'Részvizsgák',
    educationElements: 'Szakképzés elemek',
    personHasPayments: 'Befizetések',
    exports: 'Exportok',
    specialityHasCourse: 'Kötelező szakok tanfolyamonként',
    nationalities: 'Állampolgárságok'
  },

  speciality: {
    details: {
      title: 'Szak'
    },
    notification: {
      specialitySuccess: 'Szak mentése sikeres!',
      specialityError: 'Hiba a Szak mentése közben!',
      deleteSuccess: 'Szak törlése sikeres!',
      deleteError: 'Hiba a Szak törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Szak törlése',
        text: 'Biztosan törli a "{name}" nevű Szakot?'
      }
    },
    label: {
      specialtyGroup: 'szak csoport',
      educationTypeCode: 'képzés fajta kód',
      educationTypeName: 'képzés fajta'
    }
  },

  amount: {
    details: {
      title: 'Összeg'
    },
    notification: {
      amountSuccess: 'Összeg mentése sikeres!',
      amountError: 'Hiba a Összeg mentése közben!',
      deleteSuccess: 'Összeg törlése sikeres!',
      deleteError: 'Hiba a Összeg törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Összeg törlése',
        text: 'Biztosan törli a "{name}" nevű Összeget?'
      }
    }
  },

  nationality: {
    details: {
      title: 'Állampolgárság'
    },
    notification: {
      nationalitySuccess: 'Állampolgárság mentése sikeres!',
      nationalityError: 'Hiba az Állampolgárság mentése közben!',
      deleteSuccess: 'Állampolgárság törlése sikeres!',
      deleteError: 'Hiba az Állampolgárság törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Állampolgárság törlése',
        text: 'Biztosan törli a "{name}" nevű Állampolgárságot?'
      }
    }
  },
  instructorStatus: {
    details: {
      title: 'Oktatói státusz'
    },
    notification: {
      instructorStatusSuccess: 'Oktatói státusz mentése sikeres!',
      instructorStatusError: 'Hiba a Oktatói státusz mentése közben!',
      deleteSuccess: 'Oktatói státusz törlése sikeres!',
      deleteError: 'Hiba a Oktatói státusz törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Oktatói státusz törlése',
        text: 'Biztosan törli a "{name}" nevű Oktatói státuszt?'
      }
    }
  },
  educationType: {
    details: {
      title: 'Képzesi fajta'
    },
    notification: {
      educationTypeSuccess: 'Képzesi fajta mentése sikeres!',
      educationTypeError: 'Hiba a Képzesi fajta mentése közben!',
      deleteSuccess: 'Képzesi fajta törlése sikeres!',
      deleteError: 'Hiba a Képzesi fajta törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Képzesi fajta törlése',
        text: 'Biztosan törli a "{name}" nevű Képzesi fajtát?'
      }
    }
  },
  educationLocation: {
    details: {
      title: 'Képzesi hely'
    },
    notification: {
      educationLocationSuccess: 'Képzesi hely mentése sikeres!',
      educationLocationError: 'Hiba a Képzesi hely mentése közben!',
      deleteSuccess: 'Képzesi hely törlése sikeres!',
      deleteError: 'Hiba a Képzesi hely törlése közben!',
      addNoTutorSuccess: 'Tutor nélküli lehetőség mentése sikeres!',
      addNoTutorError: ' Hiba a Tutor nélküli lehetőség mentése közben!'
    },
    dialog: {
      delete: {
        title: 'Képzesi hely törlése',
        text: 'Biztosan törli a "{name}" nevű Képzesi helyet?'
      },
      addNoTutor: {
        title: 'Tutor nélküli lehetőség',
        text: 'Biztosan tutor nélkülivé teszi a képzési helyet?'
      }
    }
  },

  educationForm: {
    details: {
      title: 'Képzesi Forma'
    },
    notification: {
      educationFormSuccess: 'Képzesi forma mentése sikeres!',
      educationFormError: 'Hiba a Képzesi forma mentése közben!',
      deleteSuccess: 'Képzesi forma törlése sikeres!',
      deleteError: 'Hiba a Képzesi forma törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Képzesi Forma törlése',
        text: 'Biztosan törli a "{name}" nevű Képzesi formát?'
      }
    }
  },
  tutorReport: {
    details: {
      title: 'Tutori jelentés',
      subTitle: 'db jelentés'
    },
    notification: {
      tutorReportSuccess: 'Tutori jelentés mentése sikeres!',
      tutorReportElementAlreadyFulfilled: 'A szakképzési elemet már teljesítve lett!',
      tutorReportError: 'Hiba a Tutori jelentés mentése közben!',
      calculateSuccess: 'Tutori jelentés számolása  sikeres!',
      calculateError: 'Hiba a Tutori jelentés számolása közben!',
      deleteSuccess: 'Tutori jelentés törlése sikeres!',
      deleteError: 'Hiba a Tutori jelentés törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Tutori jelentés törlése',
        text: 'Biztosan törli a "{educationName}: {fromDate} - {toDate}" közötti Tutori jelentést?'
      }
    }
  },
  course: {
    details: {
      title: 'Tanfolyam'
    },
    notification: {
      courseSuccess: 'Tanfolyam mentése sikeres!',
      courseError: 'Hiba a Tanfolyam mentése közben!',
      deleteSuccess: 'Tanfolyam törlése sikeres!',
      deleteError: 'Hiba a Tanfolyam törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Tanfolyam törlése',
        text: 'Biztosan törli a "{name}" nevű Tanfolyamot?'
      }
    }
  },
  hospital: {
    details: {
      title: 'Kórház'
    },
    notification: {
      hospitalSuccess: 'Kórház mentése sikeres!',
      hospitalError: 'Hiba a Kórház mentése közben!',
      deleteSuccess: 'Kórház törlése sikeres!',
      deleteError: 'Hiba a Kórház törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Kórház törlése',
        text: 'Biztosan törli a "{name}" nevű Kórházat?'
      }
    }
  },
  contract: {
    details: {
      title: 'Szerződés'
    },
    notification: {
      contractSuccess: 'Szerződés mentése sikeres!',
      contractError: 'Hiba a Szerződés mentése közben!',
      deleteSuccess: 'Szerződés törlése sikeres!',
      deleteError: 'Hiba a Szerződés törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Szerződés törlése',
        text: 'Biztosan törli a "{registrationNumber}" iktatószámú Szerződést?'
      }
    }
  },
  personDetails: {
    details: {
      title: 'Alapadatok'
    },
    notification: {
      personDetailsSuccess: 'Alapadatok mentése sikeres!',
      personDetailsError: 'Hiba a Alapadatok mentése közben!',
      deleteSuccess: 'Alapadatok törlése sikeres!',
      deleteError: 'Hiba a Alapadatok törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Alapadatok törlése',
        text: 'Biztosan törli a "{name}" ú Alapadatokat?'
      }
    }
  },

  person: {
    details: {
      title: 'Személy'
    },
    notification: {
      personSuccess: 'Személy mentése sikeres!',
      personError: 'Hiba a Személy mentése közben!',
      deleteSuccess: 'Személy törlése sikeres!',
      deleteError: 'Hiba a Személy törlése közben!',
      noEducation: 'Hiba a Személynek nincsen képzése'
    },
    dialog: {
      delete: {
        title: 'Személy törlése',
        text: 'Biztosan törli a "{medicalSealNumber}-{name}" Személyt?'
      }
    },
    filter: {
      candidate: {
        label: 'jelölt filter'
        // true: 'jelölt',
        // false: 'nem jelölt'
      },
      tutor: {
        label: 'tutor filter'
        // true: 'tutor',
        // false: 'nem tutor'
      },
      passive: {
        label: 'passív filter'
        // true: 'passív',
        // false: 'aktív'
      },
      deceased: {
        label: 'elhunyt filter'
        // true: 'elhunyt',
        // false: 'élő'
      },
      diplomaType: {
        label: 'diploma típus'
      },
      personId: 'személy ID',
      educationId: 'képzés ID'
    }
  },

  qualification: {
    details: {
      title: 'Szakképesítés'
    },
    notification: {
      qualificationSuccess: 'Szakképesítés mentése sikeres!',
      qualificationError: 'Hiba a Szakképesítés mentése közben!',
      deleteSuccess: 'Szakképesítés törlése sikeres!',
      deleteError: 'Hiba a Szakképesítés törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Szakképesítés törlése',
        text: 'Biztosan törli a "{name}" nevű Szakképesítést?'
      }
    }
  },

  postGraduateEducationModule: {
    details: {
      title: 'Szakképzés modul',
      elements: 'Modul elemei',
      subModules: 'Modul almoduljai',
      moduleName: 'modul',
      subModuleName: 'almodul',
      elementName: 'elem',
      personHasEducationElementComment: 'Megjegyzés'
    },
    notification: {
      postGraduateEducationModuleSuccess: 'Szakképzés modul mentése sikeres!',
      postGraduateEducationModuleError: 'Hiba a Szakképzés modul mentése közben!',
      deleteSuccess: 'Szakképzés modul törlése sikeres!',
      deleteError: 'Hiba a Szakképzés modul törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Szakképzés modul törlése',
        text: 'Biztosan törli a "{name}" nevű Szakképzés modult?'
      }
    }
  },

  postGraduatePartExamTemplate: {
    details: {
      title: 'Részvizsga',
      partExamName: 'Részvizsga'
    },
    notification: {
      postGraduatePartExamTemplateSuccess: 'Részvizsga mentése sikeres!',
      postGraduatePartExamTemplateError: 'Hiba a Részvizsga mentése közben!',
      deleteSuccess: 'Részvizsga törlése sikeres!',
      deleteError: 'Hiba a Részvizsga törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Részvizsga törlése',
        text: 'Biztosan törli a "{name}" nevű Részvizsgát?'
      }
    },
    button: {
      addElement: 'Elem hozzáadása'
    }
  },

  transaction: {
    filter: {
      responseStatus: 'Státusz',
      ipAddress: 'IP cím',
      requestTimeFrom: 'tól',
      requestTimeTo: 'ig'
    },
    modal: {
      title: 'Tranzakció adatok',
      loginTitle: 'Bejelentkezés adatok'
    },
    label: {
      requestTime: 'Kérés ideje',
      requestURI: 'URL',
      method: 'Típus',
      responseStatus: 'Státusz',
      isSuccess: 'Sikeres',
      sessionId: 'Munkamenet',
      ipAddress: 'IP cím',
      username: 'Felhasználó',
      requestParams: 'Kérés paraméterek',
      requestBody: 'Kérés törzs'
    }
  },

  postGraduatePartExamHasElement: {
    details: {
      title: 'Részvizsga elem',
      educationElement: 'részvizsga elem',
      educationElementName: 'szakképzés elem név',
      partExamElementName: 'részvizsga elem név'
    },
    notification: {
      postGraduatePartExamHasElementSuccess: 'Részvizsga elem mentése sikeres!',
      postGraduatePartExamHasElementError: 'Hiba a Részvizsga elem mentése közben!',
      deleteSuccess: 'Részvizsga elem törlése sikeres!',
      deleteError: 'Hiba a Részvizsga elem törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Részvizsga elem törlése',
        text: 'Biztosan törli a "{name}" nevű Részvizsga elemet?'
      }
    }
  },

  educationMonth: {
    details: {
      title: 'Havi adatok',
      travelReimbursement: 'munkábajárási költségtérítés',
      travelReimbursementAmount: 'munkábajárási költségtérítés összege',
      housingReimbursement: 'lakhatási támogatás',
      housingReimbursementAmount: 'lakhatási támogatás összege',
      homeTravelReimbursement: 'hazautazási költségtérítés',
      homeTravelReimbursementAmount: 'hazautazási költségtérítés összege',
      homeTravelCount: 'hazautazások száma',
      shortageSpecialty: 'hiányszakma kifizetés',
      shortageSpecialtyAmount: 'hiányszakma kifizetés összege',
      shortageSpecialtyPayout: 'hiányszakma kifizetés dátum'
    },
    notification: {
      educationMonthSuccess: 'Havi adatok mentése sikeres!',
      educationMonthError: 'Hiba a Havi adatok mentése közben!',
      deleteSuccess: 'Havi adatok törlése sikeres!',
      deleteError: 'Hiba a Havi adatok törlése közben!',
      copySuccess: 'Havi adatok másolása sikeres!',
      copyError: 'Hiba a Havi adatok másolása közben!',
      acceptSuccess: 'Havi adatok lezárása sikeres!',
      acceptError: 'Hiba a Havi adatok lezárása közben!'
    },
    dialog: {
      copy: {
        title: 'Havi adatok másolása',
        text: 'Biztosan másolja a Havi adatokat a következő hónaphoz?'
      },
      accept: {
        title: 'Havi adatok Lezárása',
        text: 'Biztosan lezárja a Havi adatokat?'
      },
      delete: {
        title: 'Havi adatok törlése',
        text: 'Biztosan törli a Havi adatokat?'
      }
    }
  },

  postGraduateEducationElement: {
    details: {
      title: 'Szakképzés elem'
    },
    notification: {
      postGraduateEducationElementSuccess: 'Szakképzés elem mentése sikeres!',
      postGraduateEducationElementError: 'Hiba a Szakképzés elem mentése közben!',
      deleteSuccess: 'Szakképzés elem törlése sikeres!',
      deleteError: 'Hiba a Szakképzés elem törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Szakképzés elem törlése',
        text: 'Biztosan törli a "{name}" nevű Szakképzés elemet?'
      }
    }
  },

  absence: {
    details: {
      title: 'Szüneteltetés '
    },
    notification: {
      absenceSuccess: 'Szüneteltetés mentése sikeres!',
      absenceError: 'Hiba a Szüneteltetés mentése közben!',
      deleteSuccess: 'Szüneteltetés törlése sikeres!',
      deleteError: 'Hiba a Szüneteltetés törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Szüneteltetés törlése',
        text: 'Biztosan törli a Szüneteltetést?'
      }
    }
  },

  reducedWorkSchedule: {
    details: {
      title: 'Csökkentett munkarend'
    },
    notification: {
      reducedWorkScheduleSuccess: 'Csökkentett munkarend mentése sikeres!',
      reducedWorkScheduleError: 'Hiba a csökkentett munkarend mentése közben!',
      deleteSuccess: 'Csökkentett munkarend törlése sikeres!',
      deleteError: 'Hiba a csökkentett munkarend törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Csökkentett munkarend törlése',
        text: 'Biztosan törli a csökkentett munkarendet?'
      }
    },
    type: {
      SIX_HOURS: '6 órás',
      FOUR_HOURS: '4 órás',
      EIGHT_HOURS: '8 órás'
    },
    label: {
      workSchedule: 'Munkarend',
      other: 'A többi napon',
      error: 'Egy tutori jelentés csak egy munkarendet tartalmazhat!'
    },
    validation: {
      fromDate: {
        dateIsBefore: 'A dátumtól nem lehet később, mint a dátumig!'
      },
      toDate: {
        dateIsAfter: 'A dátumtig nem lehet korábban, mint a dátumtól!'
      }
    }
  },

  diplomaType: {
    ah: 'AH-Általános orvos (Honosított)',
    ao: 'AO-Általános orvos',
    b: 'B-Bölcsész',
    ek: 'EK-Egészségtudományi Kar',
    fh: 'FH-Fogorvos [ honosított]',
    fo: 'FO-Fogorvos',
    gy: 'GY-Gyógyszerész',
    hh: 'HH-Higiénikus orvos (Honosított)',
    ned: 'NED-Nem egészségüyi diploma'
  },

  tutorEnum: {
    no: 'nem tutor',
    active: 'tutor',
    passive: 'passzív tutor',
    deceased: 'elhunyt',
    NO: 'nem tutor',
    ACTIVE: 'tutor',
    PASSIVE: 'passzív tutor',
    DECEASED: 'elhunyt'
  },
  candidateEnum: {
    no: 'nem jelölt',
    active: 'jelölt',
    passive: 'passzív jelölt',
    completed: 'befejezte',
    deceased: 'elhunyt',
    NO: 'nem jelölt',
    ACTIVE: 'jelölt',
    PASSIVE: 'passzív jelölt',
    COMPLETED: 'befejezte',
    DECEASED: 'elhunyt'
  },
  prefix: {
    dr: 'Dr.',
    DR: 'Dr.',
    ifj: 'Ifj. ',
    IFJ: 'Ifj. ',
    ifj_dr: 'Ifj. Dr.',
    IFJ_DR: 'Ifj. Dr.',
    prof_dr: 'Prof. Dr.',
    PROF_DR: 'Prof. Dr.'
  },
  boolean: {
    true: 'Igen',
    false: 'Nem'
  },

  partialExamResult: {
    EXCELLENT: 'Kiválóan megfelelt',
    PASSED: 'Megfelelt',
    FAILED: 'Nem felelt meg'
  },

  workMonth: {
    details: {
      title: 'Hónap'
    },
    notification: {
      workMonthSuccess: 'Hónap mentése sikeres!',
      workMonthError: 'Hiba a Hónap mentése közben!',
      deleteSuccess: 'Hónap törlése sikeres!',
      deleteError: 'Hiba a Hónap törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Hónap törlése',
        text: 'Biztosan törli a "{name}" nevű Hónapot?'
      }
    }
  },

  personHasEducationLocation: {
    details: {
      title: 'Munkahely'
    },
    notification: {
      personHasEducationLocationSuccess: 'Munkahely mentése sikeres!',
      personHasEducationLocationError: 'Hiba a Munkahely mentése közben!',
      deleteSuccess: 'Munkahely törlése sikeres!',
      deleteError: 'Hiba a Munkahely törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Munkahely törlése',
        text: 'Biztosan törli a Munkahelyet?'
      }
    }
  },
  education: {
    details: {
      title: 'Képzés'
    },
    notification: {
      educationSuccess: 'Képzés mentése sikeres!',
      educationError: 'Hiba a Képzés mentése közben!',
      deleteSuccess: 'Képzés törlése sikeres!',
      deleteError: 'Hiba a Képzés törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Képzés törlése',
        text: 'Biztosan törli a Képzést?'
      }
    }
  },
  personHasCourse: {
    details: {
      title: 'Tanfolyam'
    },
    notification: {
      personHasCourseSuccess: 'Tanfolyam mentése sikeres!',
      personHasCourseError: 'Hiba a Tanfolyam mentése közben!',
      deleteSuccess: 'Tanfolyam törlése sikeres!',
      deleteError: 'Hiba a Tanfolyam törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Tanfolyam törlése',
        text: 'Biztosan törli a Tanfolyamot?'
      }
    }
  },
  personHasPartExam: {
    details: {
      title: 'Rész vizsga'
    },
    notification: {
      personHasPartExamSuccess: 'Rész vizsga mentése sikeres!',
      personHasPartExamError: 'Hiba a Rész vizsga mentése közben!',
      calculateSuccess: 'Rész vizsga  adat generálása sikeres!',
      calculateError: 'Hiba a Rész vizsga  adat generálása közben!',
      deleteSuccess: 'Rész vizsga  törlése sikeres!',
      deleteError: 'Hiba a Rész vizsga  törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Rész vizsga  törlése',
        text: 'Biztosan törli a Rész vizsgát?'
      }
    }
  },
  legislation: {
    details: {
      title: 'Jogszabály'
    },
    notification: {
      legislationSuccess: 'Jogszabály mentése sikeres!',
      legislationError: 'Hiba a Jogszabály mentése közben!',
      deleteSuccess: 'Jogszabály törlése sikeres!',
      deleteError: 'Hiba a Jogszabály törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Jogszabály törlése',
        text: 'Biztosan törli a "{name}" nevű Jogszabály?'
      }
    },
    filter: {
      active: {
        label: 'aktív szűrő',
        true: 'aktív',
        false: 'nem aktív'
      },
      partialExam: {
        label: 'Részvizsga filter',
        true: 'van részvizsga',
        false: 'nincs részvizsga'
      }
    }
  },
  postGraduateEducationTemplate: {
    details: {
      title: 'Szakképzés Minta',
      elementUnitType: 'mértékegység'
    },
    notification: {
      postGraduateEducationTemplateSuccess: 'Szakképzés minta mentése sikeres!',
      postGraduateEducationTemplateError: 'Hiba a Szakképzés minta mentése közben!',
      postGraduateEducationTemplateCopySuccess: 'Szakképzés minta másolása sikeres!',
      postGraduateEducationTemplateCopyError: 'Hiba a Szakképzés minta másolása közben!',
      legislationCopySuccess: 'Jogszabály másolása sikeres!',
      legislationCopyError: 'Hiba a jogszabály másolása közben!',
      deleteSuccess: 'Szakképzés minta törlése sikeres!',
      deleteError: 'Hiba a Szakképzés minta törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Szakképzés minta törlése',
        text: 'Biztosan törli a "{name}" nevű Szakképzés mintát?'
      }
    },
    copy: {
      title: 'Szakképzés minta másolása'
    },
    legislationCopy: {
      title: 'Jogszabály másolása',
      text: 'Jogszabály másolása során a jogszabályhoz tartozó szakképzés minták is másolásra kerülnek.'
    },
    filter: {
      active: {
        label: 'aktív szűrő',
        true: 'aktív',
        false: 'nem aktív'
      }
    },
    label: {
      copy: '(másolat)'
    }
  },

  yearlyEvent: {
    details: {
      title: 'Éves esemény'
    },
    notification: {
      yearlyEventSuccess: 'Éves esemény mentése sikeres!',
      yearlyEventError: 'Hiba a Éves esemény mentése közben!',
      deleteSuccess: 'Éves esemény törlése sikeres!',
      deleteError: 'Hiba a Éves esemény  törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Éves esemény törlése',
        text: 'Biztosan törli a Éves eseményt?'
      }
    }
  },

  personHasEducationElement: {
    details: {
      title: 'Szakképzés elem'
    },
    notification: {
      personHasEducationElementSuccess: 'Szakképzés elem mentése sikeres!',
      personHasEducationElementError: 'Hiba a Szakképzés elem mentése közben!',
      deleteSuccess: 'Szakképzés elem törlése sikeres!',
      deleteError: 'Hiba a Szakképzés elem törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Szakképzés elem törlése',
        text: 'Biztosan törli a Szakképzés elemt?'
      }
    }
  },
  personHasPayment: {
    details: {
      title: 'Befizetés'
    },
    notification: {
      personHasPaymentSuccess: 'Befizetés mentése sikeres!',
      personHasPaymentError: 'Hiba a Befizetésmentése közben!',
      deleteSuccess: 'Befizetés törlése sikeres!',
      deleteError: 'Hiba a Befizetés törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Befizetés törlése',
        text: 'Biztosan törli a Befizetést?'
      }
    }
  },
  specialityHasCourse: {
    details: {
      title: 'Kötelező szakok tanfolyamonként'
    },
    notification: {
      specialityHasCourseSuccess: 'Szak tanfolyamhoz adása sikeres!',
      specialityHasCourseError: 'Hiba a szak tanfolyamhoz adása közben!',
      deleteSuccess: 'Szak tanfolyamtól törlése sikeres!',
      deleteError: 'Hiba a szak tanfolyamtól törlése közben!'
    },
    dialog: {
      delete: {
        title: 'Kötelező szak törlése a tanfolyamtól',
        text: 'Biztosan törli a szakot a tanfolyamtól?'
      }
    }
  },

  legalRelationshipTypes: {
    medical_service: 'egészségügyi szolgálati jogviszony',
    individual_company_member: 'egyéni cég tagja',
    individual_health_entrepreneur: 'egyéni egészségügyi vállalkozó',
    clergy_person: 'egyházi személy',
    civil_service_status: 'közszolgálati jogviszony',
    employment_relationship: 'munkaviszony',
    volunteer_helper: 'önkéntes segítő',
    employment_service: 'szolgálati jogviszony',
    member_of_a_partnership: 'társas vállalkozás tagja'
  },
  form: {
    validator: {
      educationMonthUnique: {
        invalidMessage: 'Ez a hónap már rögzítésre került a képzéshez vagy a képzése szünetltetve van ezen az hónapon.'
      }
    }
  },
  educationalElementUnitType: {
    MONTH: 'hónap',
    WEEK: 'hét',
    DAY: 'nap',
    PIECE: 'darab'
  },

  workStatus: {
    A: 'Aktív',
    F: 'Fizetés nélküli',
    GY: 'GYES, GYED, CSED',
    H: 'Halasztó',
    K: 'Kilépett',
    TK: 'Tartósan külföldön',
    TT: 'Tartósan táppénzen',
    B: 'Befejezte',
    KL: 'Képzési ido lejárt',
    P: 'Passzív',
    PAUSED: 'Szüneteltetve'
  },

  yearlyEventType: {
    WORKDAY: 'munkanap',
    HOLIDAY: 'szabadnap'
  },
  pst: {
    161210: '161210 - Orvos-C Költségtérítéses',
    162210: '162210 - Fogorvos-C Költségtérítéses',
    163210: '163210 - Gyógyszerész-C Költségtérítéses',
    160003: '160003 - Licenc díj',
    164280: '164280 - Pszichológus-C KK foglalkoztatott'
  },
  paymentIndicationMessage: {
    notification: {
      saveSuccess: 'Kifizetés indítványozás megjegyzése mentése sikeres!',
      saveError: 'Hiba a kifizetés indítványozás megjegyzése mentése közben!'
    }
  }
};
